// Remove key for values
export function filterObj(obj, values) {
  const newObj = { ...obj };
  Object.keys(newObj).forEach((key) => {
    if (newObj[key] === values) {
      delete newObj[key];
    }
  });

  return newObj;
}

// param creater from object
export function paramCreater(obj) {
  const filteredObject = filterObj(obj, "");
  const param = new URLSearchParams(filteredObject);
  return param;
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// utils/formatters.js

// Format numbers with commas (e.g. 12000 -> 12,000)
export const fmtNumber = (num) => {
  if (num === null || num === undefined) return "-";
  return new Intl.NumberFormat("en-IN").format(num);
};

// Format dates into DD MMM YYYY (e.g. 2025-08-22 -> 22 Aug 2025)
export const fmtDate = (dateStr) => {
  if (!dateStr) return "-";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(dateStr));
};
